import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TuiSkeleton } from '@taiga-ui/kit';

@Component({
  selector: 'pxc-sidebar-department-skeleton',
  templateUrl: './sidebar-department-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, TuiSkeleton],
})
export class SidebarDepartmentSkeletonComponent {
  readonly collapsed = input(false);

  readonly rows = [0, 1, 2];
}
